import{h as D}from"./handleize-BgPkOmuO.js";import{c as z}from"./currency.cjs-D9VPANVS.js";window.themeVariables=window.themeVariables||{};window.themeVariables.nosto=window.themeVariables.nosto||{};var v;const K=((v=window.themeVariables)==null?void 0:v.settings)||{};var N;const G=((N=window.themeVariables)==null?void 0:N.strings)||{};var V;const h=((V=window.themeVariables)==null?void 0:V.nosto)||{};var x;const Y=((x=window.themeVariables)==null?void 0:x.icons)||{};var O;const W=((O=window.themeVariables)==null?void 0:O.productCard)||{};var C;const Z=((C=window.themeVariables)==null?void 0:C.cart)||{};var j;const X=((j=window.themeVariables)==null?void 0:j.customer)||null;var q;const R=((q=window.themeVariables)==null?void 0:q.product)||null;var U;const ee=((U=window.themeVariables)==null?void 0:U.collection)||null;var F;const re=((F=window.themeVariables)==null?void 0:F.search)||null,M="global-",te=h.popularitySortDefaultRuleId?`${M}${h.popularitySortDefaultRuleId}`:null,oe=h.customSortRuleId?`${M}${h.customSortRuleId}`:null,ae={settings:K,strings:G,nosto:h,icons:Y,productCard:W,cart:Z,customer:X,product:R,collection:ee,search:re,defaultPopularitySortID:te,customPopularitySortID:oe};function Pe(r,e=!1){return r?e?ie(r):se(r):null}function ie(r){if(!r)return null;const e=ne(r.skus||[]),t=H(e),o=ue(e);return{id:r.product_id||r.id,productId:r.product_id||r.id,pid:r.product_id||r.id,name:r.name||"Product",url:r.url||"",...E(r.price,r.list_price),...B(r.image_url,r.alternate_image_urls,r.thumb_url),...o,variants:e,skus:e,tags:r.tags||[],tags1:r.tags1||[],tags2:r.tags2||[],tags3:r.tags3||[],customFields:J(r.custom_fields),attributes:r.attributes||[],affinities:t,brand:r.brand,categories:r.categories||[],description:r.description,date_published:r.date_published,price_currency_code:r.price_currency_code,price_text:r.price_text,list_price_text:r.list_price_text,variant_id:r.variant_id,handle:ce(r.url,r.name)}}function se(r){var i,s;if(!r)return null;const e={...r},t=le(e.skus||[]);e.id=e.pid||e.productId||null,e.name=e.name||e.title||"Product",Object.assign(e,E(e.price,e.listPrice)),Object.assign(e,B(e.imageUrl,e.alternateImageUrls)),Object.assign(e,S(e.available,e.availability)),e.customFields=e.customFields||e.attributes||[],e.tags=e.tags1||[],e.variants=t,e.skus=t,e.handle=D(e.name);const o=((i=e.url)==null?void 0:i.split("/"))||[];e.urlHandle=o.pop()||e.handle;const a=e.customFields.find(c=>{var n;return((n=c==null?void 0:c.key)==null?void 0:n.toLowerCase())==="producttype"});return e.type=(a==null?void 0:a.value)||null,e.secondaryImage=((s=e.alternateImageUrls)==null?void 0:s.length)>0?e.alternateImageUrls[0]:null,e.affinities||(e.affinities=H(e.variants)),e}function E(r,e){return{price:parseFloat(r)||0,listPrice:parseFloat(e)||0}}function B(r,e,t=null){return{imageUrl:r||"",alternateImageUrls:e||[],...t&&{thumb_url:t}}}function S(r,e){const t=typeof r=="boolean"?r:e==="InStock";return{available:t===!0,availability:e||(t?"InStock":"OutOfStock")}}function ce(r,e){return r?r.split("/").pop():D(e||"product")}function ne(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;const t=J(e.custom_fields),{size:o,color:a}=L(t),i=S(e.available,e.availability);return{...e,customFields:t,size:o,color:a,...i}}).filter(Boolean):[]}function le(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;e.customFields=e.customFields||e.attributes||[];const{size:t,color:o}=L(e.customFields),a=S(e.available,e.availability);return{...e,size:t,color:o,...a}}).filter(Boolean):[]}function L(r){if(!Array.isArray(r))return{size:null,color:null};const e=r.find(o=>{var a;return((a=o==null?void 0:o.key)==null?void 0:a.toLowerCase())==="size"}),t=r.find(o=>{var a;return((a=o==null?void 0:o.key)==null?void 0:a.toLowerCase())==="color"});return{size:(e==null?void 0:e.value)||null,color:(t==null?void 0:t.value)||null}}function H(r){const e={};if(!Array.isArray(r)||r.length===0)return e;const t=[...new Set(r.map(a=>a.size).filter(Boolean))],o=[...new Set(r.map(a=>a.color).filter(Boolean))];return t.length>0&&(e.size=t),o.length>0&&(e.color=o),e}function ue(r){if(!Array.isArray(r)||r.length===0)return{available:!1,availability:"OutOfStock"};const e=r.some(t=>t.available===!0);return{available:e,availability:e?"InStock":"OutOfStock"}}function J(r){return!r||typeof r!="object"||Array.isArray(r)?[]:Object.entries(r).map(([e,t])=>({key:e,value:(t==null?void 0:t.toString())||""})).filter(e=>e.key&&e.value)}function Ae(r){return Array.isArray(r)?r.map(e=>{var t;return!e||typeof e!="object"?null:{keyword:e.keyword||"",redirect:e._redirect||null,highlight:((t=e._highlight)==null?void 0:t.keyword)||e.keyword||""}}).filter(Boolean):[]}function Ie(r){if(!Array.isArray(r))return{pages:[],collections:[],keywords:[]};const e=[],t=[],o=[];for(const a of r)a.redirect&&a.redirect.includes("/pages/")?e.push({title:a.keyword,url:a.redirect,highlight:a.highlight}):a.redirect&&a.redirect.includes("/collections/")?t.push({title:a.keyword,url:a.redirect,highlight:a.highlight}):o.push(a);return{pages:e,collections:t,keywords:o}}const{nosto:u,defaultPopularitySortID:k,customPopularitySortID:$}=ae,de=u.searchSizeRecs||5,me=u.autocompleteProductsSize||5,pe=u.keywordsSize||5;async function P(r,e,t){const o="https://search.nosto.com/v1/graphql",a={method:"POST",signal:t,headers:{"Content-Type":"application/json"},body:JSON.stringify({query:r,variables:e})};try{const i=await fetch(o,a);if(!i.ok){const s=await i.text();return console.error("Nosto search error:",{status:i.status,statusText:i.statusText,responseBody:s}),null}return await i.json()}catch(i){return console.error("Error fetching from Nosto API:",i),null}}async function fe(r){const e="https://api.nosto.com/v1/graphql",t={method:"POST",headers:{"Content-Type":"application/json",Authorization:"Basic "+btoa(`:${u.authToken}`)},mode:"cors",body:JSON.stringify({query:r})};try{const o=await fetch(e,t);if(!o.ok){const a=await o.text();return console.error("Nosto recommendations error:",{status:o.status,statusText:o.statusText,responseBody:a}),null}return await o.json()}catch(o){return console.error("Error fetching from Nosto Recommendations API:",o),null}}async function _e(r,e,t,o,a,i="collection",s,c){var g,I,_;const{productsPerPage:n,from:b}=t;let l,p;t.pageNumber>1&&o===0?(l=0,p=n*t.pageNumber-a):t.pageNumber>1&&o>0?(l=o,p=n):(l=b,p=n);const d={segments:u.abTestSegments||[],products:{size:p,from:l}};(g=t.sort)!=null&&g.field&&((I=t.sort)!=null&&I.order)&&t.sort.field!=="popularity"&&(d.products.sort=t.sort),i==="collection"&&(d.products.categoryId=r);const A=i==="search"&&s?`query: "${s}",`:"";e!=null&&e.length&&(d.products.filter=e);let f="";if($&&((_=t.sort)==null?void 0:_.field)==="popularity"){let m=`{id: "${$}", enabled: true}`;k&&(m+=`,{id: "${k}", enabled: false}`),f=`customRules: [${m}],`}const y=`
    query (
      $segments: [String!],
      $products: InputSearchProducts,
      $abTests: [InputSearchABTest!]
    ) {
      search(
        accountId: "${u.siteId}",
        ${A}
        ${f}
        segments: $segments
        products: $products,
        keywords: {
          size: ${pe}
        }
        abTests: $abTests
      ) {
        redirect
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          fuzzy
          facets {
            ... on SearchStatsFacet {
              name
              field
              min
              max
              id
            }
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                count
                selected
              }
              id
            }
          }
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        abTests {
          id
          name
          activeVariation {
            id
          }
          allVariations {
            id
          }
        }
      }
    }
  `;try{return await P(y,d,c)}catch(m){throw console.error("Nosto search error:",m),m}}async function ze(r){const e={products:{size:me,from:0}},t=`
    query (
      $products: InputSearchProducts
    ) {
      search(
        accountId: "${u.siteId}",
        query: "${r}",
        products: $products,
        keywords: {
          size: 20
        },
        categories: {
          size: 10
        }
      ) {
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          facets {
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                selected
              }
              id
            }
          }
          fuzzy
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        categories {
          hits {
            name
            url
          }
          total
        }
      }
    }
  `;try{return await P(t,e)}catch(o){return console.error("Nosto autocomplete search error:",o),null}}async function ke(r=5){var t,o,a;const e=`
    {
      search(
        accountId: "${u.siteId}"
        query: ""
        popularSearches: {size: ${r}, emptyQueryMatchesAll: true}
      ) {
        popularSearches {
          hits {
            query
            total
          }
          total
        }
        query
      }
    }
  `;try{const i=await P(e,{});return((a=(o=(t=i==null?void 0:i.data)==null?void 0:t.search)==null?void 0:o.popularSearches)==null?void 0:a.hits)||[]}catch(i){return console.error("Nosto popular searches error:",i),null}}const ye=r=>r?`exclude: {
      productIds: '${r}'
    },`:"",he=r=>r?`include: {
      productIds: '${r}'
    },`:"",ge=r=>{const e=r.excludeProducts&&r.excludeProducts.length?ye(JSON.stringify(r.excludeProducts)):"",t=r.includeProducts&&r.includeProducts.length?he(JSON.stringify(r.includeProducts)):"";return`toplist(
    hours: ${r.toplistHours},
    sort: ${r.toplistScoringMode},
    params: {
      maxProducts: ${r.searchSize||de},
      ${e}
      ${t}
    }
  )`};async function $e(r){let e;e=ge(r);const t=`{
    recos(
      preview: false,
      image: VERSION_SOURCE
    ) {
      ${e} {
        primary {
          productId
          name
          url
          price
          listPrice
          imageUrl
          alternateImageUrls
          availability
          tags1
          skus {
            id
            name
            availability
            price
            imageUrl
            attributes {
              key
              value
            }
          }
          attributes {
            key
            value
          }
        }
      }
    }
  }`;try{return await fe(t)}catch(o){return console.error("Nosto recommendations error:",o),null}}function ve(r,e,t){if(!r||!e||!t){console.warn("Missing required product data for Nosto tracking");return}window.nostojs(o=>{o.recordSearchClick(r,{productId:e,url:t})})}function Ne(r,e,t){if(Object.keys(e).length===0)return;const o={query:e.term,products:{sort:e.sort,filter:e.filter}},a={products:{hits:Array.isArray(t)?t.map(s=>({productId:s.productId})):[],fuzzy:e.fuzzy,size:e.size,from:e.from,total:e.total},properties:{}},{abTests:i}=e;if(i!=null&&i.length){const s=Object.fromEntries(i.filter(c=>{var n;return c.id&&((n=c.activeVariation)==null?void 0:n.id)}).map(c=>[c.id,c.activeVariation.id]));Object.keys(s).length&&(a.properties.abTestAttribution=s,a.abTests=i)}r==="category"&&(a.products.categoryPath=e.term),window.nostojs(s=>{s.recordSearch(r,o,a)})}function Ve(r,e){if(!r){console.warn("Missing product ID for Nosto recommended product tracking");return}window.nostojs(t=>{t.recommendedProductAddedToCart(r,e||"")})}const Q=()=>{var e;const r=document.querySelector("cart-drawer .nosto_element");r&&((e=window.Nosto)==null||e.reloadCart([r.id]),setTimeout(()=>{r.style.opacity="1"},2e3))};document.addEventListener("cart-drawer:refreshed",()=>{Q()});document.addEventListener("DOMContentLoaded",()=>{Q()});function xe(r,e=!1){const t=r.urlHandle||r.handle;if(!r||!t)return null;const o=document.createElement("nosto-dynamic-card");return o.setAttribute("handle",t),o.setAttribute("template",e?"eager-card":"card"),o.setAttribute("data-nosto-product-id",r.id),o.innerHTML=`
    <div class="twp-product-card-skeleton product-card">
      <div class="product-card__figure">
        <div class="product-card__media">
          <div class="twp-product-card-skeleton__image product-card__image product-card__image--primary aspect-tall"></div>
        </div>
      </div>
    </div>
  `,o}var T;const w=((T=window.themeVariables)==null?void 0:T.settings)||{},be=(r,e=!0)=>{const t=window.Shopify.currency.active,o=w.shopCurrency,a=e?w.moneyFormat:w.moneyWithoutCurrencyFormat;if(o===t)return z.formatMoney(r*100,a);let i=r*100*window.Shopify.currency.rate,s=!1,c=0,n=0,b=.1,l=.05;switch(t){case"USD":case"HKD":case"SAR":case"AED":l=0;break;case"NZD":l=.1,c=.15;break;case"JPY":s=!0;break;case"SGD":l=.05,c=.09;break;case"CAD":l=.05,n=.03;break;default:l=.05}n!==0&&(i=i*(1+n)),o==="AUD"&&c!==0&&(i=i/(1+b)*(1+c));const d=Math.floor(i)/100;let f=(Math.ceil(d)-l)*100;if(s){const y=Math.trunc(i),g=y.toString().slice(-3);f=parseInt(g)>=50?Math.ceil(y/1e4)*1e4:Math.floor(y/1e4)*1e4}return z.formatMoney(f,a)};window.theme.localPrice=window.localPrice||be;export{Ve as a,ve as b,ae as c,Ne as d,$e as e,ze as f,_e as g,Ae as h,ke as i,be as l,xe as n,Ie as s,Pe as t};
